const DOCUMENT_RELATIVE_INDEX_PATH = 'document-processor';
const RESULTS_RELATIVE_INDEX_PATH = 'results';

export const DOCUMENT_ROUTE_PREFIX = `/dashboard/${DOCUMENT_RELATIVE_INDEX_PATH}`;

interface DocumentProcessorRoutes {
  index: {
    getUrl: () => string;
    path: string;
    relativePath: string;
  };
  parseResult: {
    getUrl: (documentId: string, documentType: string) => string;
    path: string;
    relativePath: string;
  };
}

const documentProcessorRoutes: DocumentProcessorRoutes = {
  index: {
    getUrl: () => DOCUMENT_ROUTE_PREFIX,
    path: DOCUMENT_ROUTE_PREFIX,
    relativePath: `${DOCUMENT_RELATIVE_INDEX_PATH}/*`
  },
  parseResult: {
    getUrl: (documentId: string, documentType: string) =>
      `${DOCUMENT_ROUTE_PREFIX}/${RESULTS_RELATIVE_INDEX_PATH}/${documentId}/${documentType}`,
    path: `${DOCUMENT_ROUTE_PREFIX}/${RESULTS_RELATIVE_INDEX_PATH}/:id/:documentType`,
    relativePath: `${RESULTS_RELATIVE_INDEX_PATH}/:id/:documentType`
  }
};

export default documentProcessorRoutes;
